module.exports = __webpack_public_path__ + "static/media/celular.5eba35a2.svg";